import React, { PureComponent } from 'react';
import { func, bool, any } from 'prop-types';
import { reduxForm, formValueSelector } from 'redux-form';
import { connect } from 'react-redux';
import Radium from 'radium';
import { handleKeyDown } from '@widergy/utilitygo-forms-web';
import { scrollToInvalid } from '@widergy/web-utils/lib/form';
import { UTButton, UTLoading } from '@widergy/energy-ui';

import { ROUTES } from 'constants/routes';

import AuthFormBox from '../../../../components/AuthFormBox';
import { message } from '../../../../../utils/stringUtils';
import { SIGNUP_PERSONAL_INFO } from '../../../../../constants/reduxForms';
import ReturnToSignIn from '../ReturnToSignIn';
import { gaTrackPageView } from '../../../../../services/AnalyticsService';

import PersonalInformation from './layout';
import stylesJS from './styles';
import styles from './styles.module.scss';

class PersonalInformationContainer extends PureComponent {
  componentDidMount() {
    gaTrackPageView(ROUTES.SIGN_UP);
  }

  componentWillUnmount = () => this.props.resetFields();

  render() {
    return (
      <form
        onSubmit={this.props.handleSubmit}
        onKeyDown={handleKeyDown(this.props.handleSubmit)}
        style={stylesJS.container}
      >
        <AuthFormBox title={message('Signup:completeYourInformation')}>
          <UTLoading loading={this.props.loading}>
            <PersonalInformation fieldValues={this.props.fieldValues} fields={this.props.fields} />
            <UTLoading loading={this.props.userIdentificationLoading} />
          </UTLoading>
        </AuthFormBox>
        {!this.props.loading && (
          <UTButton
            disabled={this.props.userIdentificationLoading || (this.props.submitFailed && this.props.invalid)}
            type="submit"
            className={styles.action}
          >
            {message('Signup:next')}
          </UTButton>
        )}
        {!this.props.loading && <ReturnToSignIn />}
      </form>
    );
  }
}

const form = reduxForm({ form: SIGNUP_PERSONAL_INFO, onSubmitFail: errors => scrollToInvalid(errors) })(
  Radium(PersonalInformationContainer)
);
const formSelector = formValueSelector(SIGNUP_PERSONAL_INFO);

const mapStateToProps = (store, props) => ({
  fieldValues: formSelector(store, ...props.fields.map(field => `id${field.id}`)),
  userIdentificationLoading: store.auth.userIdentificationLoading
});

PersonalInformationContainer.propTypes = {
  handleSubmit: func.isRequired,
  resetFields: func.isRequired,
  userIdentificationLoading: bool,
  loading: bool,
  fieldValues: any, // eslint-disable-line react/forbid-prop-types
  fields: any, // eslint-disable-line react/forbid-prop-types
  submitFailed: bool,
  invalid: bool
};

export default connect(mapStateToProps)(form);
